import { Button, soundManager, t, useVoucherStore } from '@slot-nx/core'
import { Container, Text } from '@pixi/react'
import { Text as PixiText, TextStyle } from 'pixi.js'
import { useCallback, useRef } from 'react'
import { MachineActionType, sweetBombMachine } from '../../../../machine/sweetbombMachine'
import { VoucherSoundType } from '../../../domain/soundManager/enum/VoucherSoundType'

export const playNowBtnTextStyle = new TextStyle({
  align: 'center',
  fontWeight: 'normal',
  fill: '#FFFFFF',
  fontFamily: 'RobotoCondensed',
  fontSize: 45,
})

export const VoucherSelectPopupButtons = () => {
  const sendEventCb = useCallback(() => {
    useVoucherStore.setState({ isShowVoucherSelectPopup: false })
  }, [])
  const playNowTextRef = useRef<PixiText>()
  const playLaterTextRef = useRef<PixiText>()

  return (
    <Container name="VoucherButtons">
      <Button
        name="play_later_btn"
        defaultView="voucher_play_later_normal"
        hoverView="voucher_play_later_hover"
        pressedView="voucher_play_later_click"
        disabledView="voucher_play_later_unable"
        enabled={true}
        x={-380}
        y={440}
        width={341}
        height={157}
        key="play_later_btn"
        onPressing={() => {
          (playLaterTextRef.current as PixiText).position.y = 515
        }}
        onHoverEnd={() => {
          (playLaterTextRef.current as PixiText).position.y = 508
        }}
        onPress={() => {
          soundManager.play(VoucherSoundType.buttonClick)
          sweetBombMachine.send({ type: MachineActionType.voucherBackToMainGame })
          sendEventCb()
        }}
      />
      <Text
        text={t('voucher_select_popup_play_later_btn')}
        x={-207}
        y={508}
        anchor={[0.5, 0.5]}
        name="PLAY LATER"
        style={new TextStyle({
          align: 'center',
          fontWeight: 'normal',
          fill: '#B49CFF',
          fontFamily: 'RobotoCondensed',
          fontSize: 45,
        })}
        ref={(el) => {
          playLaterTextRef.current = el as PixiText
        }}
      />
      <Button
        name="play_now_btn"
        defaultView="voucher_play_now_normal"
        hoverView="voucher_play_now_hover"
        pressedView="voucher_play_now_click"
        disabledView="voucher_play_now_unable"
        enabled={true}
        x={30}
        y={440}
        width={341}
        height={157}
        key="play_now_btn"
        onPressing={() => {
          (playNowTextRef.current as PixiText).position.y = 515
        }}
        onHoverEnd={() => {
          (playNowTextRef.current as PixiText).position.y = 508
        }}
        onPress={() => {
          soundManager.play(VoucherSoundType.buttonClick)
          // useGameStore.setState({ gameStatus: GameStatus.Voucher })
          sweetBombMachine.send({ type: MachineActionType.voucherTimeStart })
          sendEventCb()
        }}
      />
      <Text
        text={t('voucher_select_popup_play_now_btn')}
        x={205}
        y={508}
        anchor={[0.5, 0.5]}
        name="PLAY NOW"
        style={playNowBtnTextStyle}
        ref={(el) => {
          playNowTextRef.current = el as PixiText
        }}
      />

    </Container>
  )
}
